<template>
  <div>


    <div class="header-wrap">
      <div class="btn-back" v-if="" @click="goBack"/>
      <div class="wel">
        <span>{{title}}</span>
      </div>
    </div>


    <div class="item-list">
      <div class="content">

        <div class="box">
          <div class="label">效果图</div>
          <img :src="imgDomain + detail.scheme_pic" alt>
          <div class="line"></div>
        </div>

        <div class="box">
          <div class="label">安装结构图</div>
          <img @click="showBigPic(detail.scheme_install_pic)" class="structure-img" :src="imgDomain + detail.scheme_install_pic" alt>
          <img class="magnifying-lens" src="../../assets/img/goods_detail/lens.png" alt>
          <div class="line"></div>
        </div>

        <div class="box">
          <div class="label">定制详情</div>
          <div class="main2">
            <table>
              <tr v-if="custom_detail.all_product_count">
                <td rowspan="2">主材</td>
                <td>展开总面积</td><td>{{ custom_detail.all_product_area }} m²</td>
              </tr>
              <tr v-if="custom_detail.all_product_count">
                <td>构件数量</td><td>{{ custom_detail.all_product_count }} 个</td>
              </tr>
              <tr v-for="(item,index) in custom_detail.door_products" :key="index">
                <td v-if="!index" :rowspan="custom_detail.door_products.length">门</td>
                <td>{{ item.product_name }}</td><td>{{ item.product_count }} {{ item.product_unit }}</td>
              </tr>
              <tr v-for="(item,index) in custom_detail.zj_products" :key="index+1">
                <td v-if="!index" :rowspan="custom_detail.zj_products.length">功能组件</td>
                <td>{{ item.product_name }}</td><td>{{ item.product_count }} {{ item.product_unit }}</td>
              </tr>
            </table>
          </div>
          <div class="line"></div>
        </div>

        <div class="box">
          <div class="label">商品BOM</div>
          <div class="bom-list">
            <div class="item" @click="jumpProductDetail(detail, 0, detail.plate_price)">
              <div>·   柜体构件明细</div>
              <div class="val">￥{{ detail.plate_price || '0.00' }}</div>
              <span class="icon dk-iconfont">&#xe63b;</span>
            </div>
            <div class="item" @click="jumpProductDetail(detail, 1, detail.zj_price)">
              <div>·   功能组件明细</div>
              <div class="val">￥{{ detail.zj_price || '0.00' }}</div>
              <span class="icon dk-iconfont">&#xe63b;</span>
            </div>
            <div class="item" @click="jumpProductDetail(detail, 2, detail.wujin_price)">
              <div>·   五金附件明细</div>
              <div class="val">￥{{ detail.wujin_price || '0.00' }}</div>
              <span class="icon dk-iconfont">&#xe63b;</span>
            </div>
            <div class="item" @click="jumpProductDetail(detail, 3, detail.door_price)">
              <div>·   滑动门明细</div>
              <div class="val">￥{{ detail.door_price || '0.00' }}</div>
              <span class="icon dk-iconfont">&#xe63b;</span>
            </div>
            <div class="item" @click="jumpProductDetail(detail, 4, detail.shoukou_price)">
              <div>·   收口附件明细</div>
              <div class="val">¥{{ detail.shoukou_price || '0.00' }}</div>
              <span class="icon dk-iconfont">&#xe63b;</span>
            </div>
          </div>
        </div>

        <!--<div class="tip"><img src="../assets/img/ic-tag.png" alt="tag">所有标签均可多选，魔方屋将为您匹配多种整配方案。</div>

        <div class="question" v-for="(question, key) in surveyList">
          <div class="title">{{question.title}}<span v-if="question.need">(必填)<span class="red"> *</span></span></div>
          <div class="opt-wrap">
            <div class="opt" :class="{selected:opt.selected}" v-for="opt in question.options" @click="select(opt)">{{opt.label}}</div>
          </div>
          <div class="line" v-if="surveyList.length - 1 !== key"></div>
        </div>-->

      </div>
    </div>


  </div>
</template>

<script>
  import store from "../../vuex/store"

  export default {
    name: "ChestDetail",
    data(){
      return{
        title: '',

        detail: {},         // 柜子详情
        custom_detail: {},  // 定制详情
      }
    },
    created() {
      let detail = store.state.pageParam
      this.resolveDetail(detail)
    },
    methods:{
      resolveDetail(detail){
        if(!detail) return

        console.log("detail", detail)
        this.detail = detail
        let {scheme_name} = detail

        this.title = scheme_name

        this.resolveInfo(this.detail)
      },
      resolveInfo(data){
        this.custom_detail = JSON.parse(JSON.stringify(data))

        const { plate_products, score_products, wujin_products, door_products, door } = this.custom_detail

        // 主材（总面积｜构件数量）
        let all_product_area = 0
        if (plate_products) {
          plate_products.forEach((item) => {
            all_product_area += item.product_area
          })
        }
        this.custom_detail.all_product_area = all_product_area.toFixed(2)

        this.custom_detail.all_product_count = 0
        if(score_products){
          score_products.forEach((item) => {
            this.custom_detail.all_product_count += item.product_count
          })
        }


        // 功能组件（衣通杆）
        let ytgList = []
        let ytgCount = 0
        if(wujin_products){
          wujin_products.forEach((item) => {
            const index = item.product_no.indexOf('W06-01')
            if(index >= 0){
              ytgCount += item.product_count
              ytgList.push(item)
            }
          })
        }
        if(ytgList.length){
          ytgList[0].product_count = ytgCount
          this.custom_detail.zj_products.push(ytgList[0])
        }

        // 拉篮 裤抽
        let countItem = (productName) => {
          let firstItem = undefined
          let count = 0
          for(let i = 0; this.custom_detail.zj_products.length > i; i++) {
            let item = this.custom_detail.zj_products[i]

            if (item.product_name === productName) {
              if (!firstItem) firstItem = this.custom_detail.zj_products[i]
              if (count > 0){
                this.custom_detail.zj_products.splice(i, 1)
                i --
              }
              count += item.product_count
            }

          }
          firstItem.product_count = count
        }
        countItem('拉篮')
        countItem('裤抽')

        // 门（数量｜移门缓冲器）
        let ymhcqItem = ''
        if (door_products){
          door_products.forEach((item) => { if(item.product_no === 'W04-20-XX-00') ymhcqItem = item })
        }
        this.custom_detail.door_products = []
        if(ymhcqItem) this.custom_detail.door_products.push(ymhcqItem)
        if(door && door.door_has_count){
          this.custom_detail.door_products.push({
            product_name: '移动门',
            product_count: door.door_has_count,
            product_unit: '扇'
          })
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .header-wrap{
    height: 1.14rem;
    display: flex;
    justify-content: space-between;
    width: 100%;
    background-size: 150% auto;
    color: #FFFFFF;
    background: #00D6C6;
    padding: 0.58rem 0.3rem 0;
    .btn-back{
      width: 0.34rem;
      height: 0.34rem;
      background: url("../../assets/img/ic_header_back.png") no-repeat;
      background-size: auto 100%;
    }
    .wel {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      font-size: 0.4rem;
      line-height: 1;
    }
  }

  .item-list {
    padding-top: 0.26rem;
    height: calc(100vh - 1.14rem);
    overflow: auto;
    .content {
      width: 6.9rem;
      margin: 0 auto 0.26rem auto;
      background: #ffffff;
      padding: 0.3rem 0.4rem;
      border-radius: 0.14rem;
      .box{
        position: relative;
        .label{
          font-size: .28rem;
          font-weight: bold;
          padding: .3rem 0 .1rem 0;
        }
        .structure-img{
          width: 100%;
        }
        .magnifying-lens{
          position: absolute;
          bottom: .45rem;
          right: .25rem;
          width: .4rem;
          pointer-events: none;
        }
        img{
          width: 100%;
        }
        .main2 {
          table {
            width: 100%;
            td {
              color: #828282;
              height: 0.5rem;
              text-align: center;
              &:nth-child(1),
              &:nth-child(2) {
                background: #E7E7E7;
              }
              &[rowspan] {
                background: #D9D9D9;
              }
              &:last-child {
                background: #F3F3F3;
              }
            }
          }
        }
        .bom-list{
          .item{
            width: 100%;
            height: 0.7rem;
            display: flex;
            align-items: center;
            background: #F9F9F9;
            color: #828282;
            font-size: 0.2rem;
            padding: 0 0.18rem;
            .icon{
              font-size: 0.15rem;
            }
            .val{
              margin-left: auto;
              margin-right: 0.3rem;
            }
            & + .item{
              margin-top: 0.05rem;
            }
          }
        }
        .line{
          position: relative;
          width: 6.9rem;
          transform: translate(-.4rem);
          border-bottom: solid #e7e7e7 1px;
          margin-top: .25rem;
        }
      }
    }
  }
</style>
